var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubgrupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #181a34;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1077.49,450.13c0-.37,0-.75-.06-1.12,0-1-.1-2-.22-3,0-.45-.13-.89-.2-1.34-.15-.94-.34-1.87-.56-2.79-.09-.38-.19-.76-.29-1.13-.3-1.08-.65-2.14-1.05-3.17-.07-.18-.1-.36-.17-.53l-.23-.55,0-.13-62.39-156a71.33,71.33,0,0,0-66.54-45H790.83V199.57A35.84,35.84,0,0,0,755,163.73H74.17A71.76,71.76,0,0,0,2.5,235.4V737.07a71.75,71.75,0,0,0,71.67,71.66h58.28a143.36,143.36,0,0,0,277.6,0H670a143.36,143.36,0,0,0,277.6,0h58.28a71.75,71.75,0,0,0,71.67-71.66V450.4C1077.5,450.31,1077.49,450.22,1077.49,450.13ZM811.39,307.07H945.74l32.09,80.22a19.89,19.89,0,0,1-18.46,27.28H790.83V327.62A20.56,20.56,0,0,1,811.39,307.07ZM74.17,235.4h645V522.07h-645ZM271.25,844.57a71.67,71.67,0,1,1,71.67-71.67,71.67,71.67,0,0,1-71.67,71.67Zm537.5,0a71.67,71.67,0,1,1,71.67-71.67A71.67,71.67,0,0,1,808.75,844.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubgrupo);
export default __webpack_public_path__ + "static/media/subgrupo.a09bd61fe9429529dfbc57b492ed9e79.svg";
export { ForwardRef as ReactComponent };